import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';

/** Element the overlay is portalled into — the content area beside the sidebar. */
export const CONTENT_REGION_ID = 'app-content-region';

interface PageLoadingOverlayProps {
  /** Text shown next to the spinner, e.g. "Loading timeline...". */
  message: string;
}

/**
 * Loading overlay covering the page content area — the sidebar menu stays
 * visible and usable — with a centred card on a dimmed backdrop.
 */
export function PageLoadingOverlay({ message }: PageLoadingOverlayProps) {
  const [contentRegion, setContentRegion] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContentRegion(document.getElementById(CONTENT_REGION_ID));
  }, []);

  const card = (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className="absolute inset-0 bg-background/50 z-[100] flex items-center justify-center cursor-not-allowed"
    >
      <div className="flex items-center gap-3 bg-background border rounded-lg px-5 py-3 shadow-lg">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-sm font-medium">{message}</span>
      </div>
    </div>
  );

  if (!contentRegion) return null;
  return createPortal(card, contentRegion);
}
